module.exports = __webpack_public_path__ + "img/house_16.ae0521eb.jpg";